import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  buildDurationTitle: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.buildDurationTitle',
    description: 'Title for the build duration metric card',
    defaultMessage: 'Build duration',
  },
  buildSuccessRateTitle: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.buildSuccessRateTitle',
    description: 'Title for the build success rate metric card',
    defaultMessage: 'Build success rate',
  },
  deploymentSuccessRateTitle: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.deploymentSuccessRateTitle',
    description: 'Title for the deployment success rate metric card',
    defaultMessage: 'Deployment success rate',
  },
  chartLoadFailedText: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.chartLoadFailedText',
    description: 'Text for fetching duration data failed',
    defaultMessage: 'Failed to load chart',
  },
  noJiraMessageText: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.noJiraMessageText',
    description: 'Text for no jira linked repository found',
    defaultMessage: 'To view pipeline metrics, consider {link}',
  },
  jiraLink: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.jiraLink',
    description: 'Text for jira link',
    defaultMessage: 'linking this repository to Jira',
  },
  noDataMessageText: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.noDataMessageText',
    description: 'Text for no data available',
    defaultMessage: 'No data available',
  },
  timeRange: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.timeRange',
    description: 'Text for time range chart tooltip value',
    defaultMessage: 'Time range',
  },
  count: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.count',
    description: 'Text for count chart tooltip value',
    defaultMessage: 'Count',
  },
  duration: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.duration',
    description: 'Text for duration chart tooltip value',
    defaultMessage: 'Duration',
  },
  failureRate: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.failureRate',
    description: 'Text for failure rate chart tooltip value',
    defaultMessage: 'Failure rate',
  },
  successRate: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.successRate',
    description: 'Text for success rate chart tooltip value',
    defaultMessage: 'Success rate',
  },
  passed: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.passed',
    description: 'Text for passed chart tooltip value',
    defaultMessage: 'Passed',
  },
  failed: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.failed',
    description: 'Text for failed chart tooltip value',
    defaultMessage: 'Failed',
  },
  skipped: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.skipped',
    description: 'Text for skipped chart tooltip value',
    defaultMessage: 'Skipped',
  },
  testFailureRateTitle: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.testFailureRateTitle',
    description: 'Title for the test failure rate metric card',
    defaultMessage: 'Test failure rate',
  },
  valueIncreasedDescription: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.valueIncreasedDescription',
    description: 'Description for the metric cards when value decreased',
    defaultMessage:
      '{chartTitle} has increased by {difference} comparing to the average over the previous {numberOfPreviousWeeks} weeks',
  },
  valueDecreasedDescription: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.valueDecreasedDescription',
    description: 'Description for the metric cards when value decreased',
    defaultMessage:
      '{chartTitle} has decreased by {difference} comparing to the average over the previous {numberOfPreviousWeeks} weeks',
  },
  buildMetrics: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.buildMetrics',
    description: 'Label of the build metrics group',
    defaultMessage: 'Build metrics',
  },
  testMetrics: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.testMetrics',
    description: 'Label of the test metrics group',
    defaultMessage: 'Test metrics',
  },
  deploymentMetrics: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.deploymentMetrics',
    description: 'Label of the deployment metrics group',
    defaultMessage: 'Deployment metrics',
  },
  environmentPlaceholder: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.environmentPlaceholder',
    description: 'Placeholder of deployment environment select input',
    defaultMessage: 'Environment',
  },
  noDataLastWeek: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.noDataLastWeek',
    description: 'Text for no data available',
    defaultMessage: 'No data available for the most recent week',
  },
  frequency: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.frequency',
    description: 'Text for frequency chart tooltip value',
    defaultMessage: 'Frequency',
  },
  deploymentFrequencyTitle: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.deploymentFrequencyTitle',
    description: 'Title for the deployment frequency metric card',
    defaultMessage: 'Deployment frequency',
  },
  deploymentFrequencyNonProd: {
    id: 'frontbucket.pipelines.list.sidebar.metrics.deploymentFrequencyNonProd',
    description: 'Description for the deployment frequency metric card',
    defaultMessage:
      'Deployment frequency only available for Production environments',
  },
});
